import styled from 'styled-components';

export const MyEverBrightModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 380px;
  padding: 62px 12px 88px;
`;

export const AppStoreButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

export const StyledImg = styled.img`
  height: 130px;
  width: 130px;
`;
